<template>
  <div class="OrderTable">
    <div class="top_bar">
      <div class="case" style="text-align: right">
        <div class="case-title">
          <img class="case-title_icon" src="@/assets/images/icon_lb@2x.png" alt />
          <div class="case-title_max">
            关联订单记录<span style="color: #ff5757; margin-left: 5px"></span>
          </div>
        </div>
      </div>
      <div>
        <el-button size="small" type="success" icon="el-icon-download" :loading="downloadLoading"
          @click="exportExcel">导出Excel</el-button>
      </div>
    </div>

    <!-- table -->
    <div v-if="this.total > 0">
      <div v-for="(item, index) in orderTableList" :key="index" class="order_list">
        <div class="line_top"></div>
        <div class="table_title" :style="{
          background: '#E4ECFD',
        }">
          <div class="left">
            <div style="margin-left: 0">
              <div>{{ index + 1 }}</div>
            </div>
            <div style="display: flex; align-items: center; margin-left: 35px">
              <span>厂商:</span>
              <span>{{ item.manufacturerName }}</span>
            </div>
            <div>
              <span>旧机串号:</span>
              <span style="text-decoration: underline;cursor: pointer;" @click="jumpToClick(item, 'chuanhao')">{{
                item.imei
              }}</span>
            </div>
            <div>
              <span>主商户渠道:</span>
              <span>{{ item.mainChannelNameMajor }}</span>
            </div>
            <div>
              <span>下单渠道:</span>
              <span>{{ item.mainChannelNames }}</span>
            </div>
            <div>
              <span>中标渠道:</span>
              <el-tooltip class="item" effect="dark" :content="item.mainChannelNameFXGet" placement="top-start">
                <span style="color:#ff5757">{{ truncateString(item.mainChannelNameFXGet, 3) }}</span>
              </el-tooltip>
            </div>
            <div>
              <span style="color: orange;">主订单号:</span>
              <span style="text-decoration: underline;color: orange;cursor: pointer;"
                @click="jumpToClick(item, 'dingdanhao')">{{
                  item.orderNoMajor
                }}</span>
            </div>
          </div>
        </div>
        <el-table :data="item.orderGroupRelationshipDtos" border :row-class-name="tableRowClassName">
          <el-table-column type="index" width="50" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="channelName" label="外部渠道" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isMajorOrder ? 'warning' : ''" effect="dark" size="mini">{{
                scope.row.isMajorOrder ? '主' :
                  '从' }}</el-tag>
              {{ scope.row.channelName }}
            </template>
          </el-table-column>
          <el-table-column prop="createCompanyName" label="下单商户" align="center">
          </el-table-column>
          <el-table-column prop="imei" label="旧机串号" align="center">
          </el-table-column>
          <el-table-column prop="typeName" label="分类" align="center">
          </el-table-column>
          <el-table-column prop="phoneName" label="机型" align="center">
          </el-table-column>
          <el-table-column prop="address" label="旧机照片" align="center">
            <template slot-scope="scope">
              <div v-if="
                scope.row.images
              ">
                <el-button @click="openImgBox(scope.row)" style="text-decoration: underline;cursor: pointer;"
                  type="text">共{{
                    scope.row.images.length }}张</el-button>
              </div>
              <div v-else>暂无图片</div>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="订单状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.state === '00'">待确认</span>
              <span v-else-if="scope.row.state === '01'">已确认</span>
              <span v-else-if="scope.row.state === '02'">待支付</span>
              <span v-else-if="scope.row.state === '03'">已绑码</span>
              <span v-else-if="scope.row.state === '04'">已收货</span>
              <span v-else-if="scope.row.state === '05'">降价收货</span>
              <span v-else-if="scope.row.state === '10'">已取消</span>
              <span v-else-if="scope.row.state === '20'">已作废</span>
              <span v-else-if="scope.row.state === '30'">已退回</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" label="繁星订单号" align="center" width="180">
            <template slot-scope="scope">
              <span style="text-decoration: underline;cursor: pointer;color: #0981ff;" type="text"
                @click="jumpToClick(scope.row, 'fanxingdingdan')">{{ scope.row.orderNo
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderTime" label="下单时间" align="center">
          </el-table-column>
          <el-table-column prop="orderNoOut" label="外部订单号" align="center">
            <template slot-scope="scope">
              <span style="color: orange;">{{ scope.row.orderNoOut
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shopId" label="厂商门店ID" align="center">
            <template slot-scope="scope">
              <span>{{ !scope.row.shopId || scope.row.shopId == 'null' ? '--' : scope.row.shopId }}</span>

            </template>

          </el-table-column>
          <el-table-column prop="employeeId" label="厂商店员ID" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employeeId && scope.row.employeeId != 'null' ? scope.row.employeeId : '--' }}</span>

            </template>

          </el-table-column>
          <el-table-column prop="chxPrice" width="100" label="繁星推送报价" align="center">
          </el-table-column>
          <el-table-column prop="isFXGet" width="100" label="繁星是否中标" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isFXGet" style="color: red;">已中标</span>
              <span v-else>未中标</span>
            </template>
          </el-table-column>
          <el-table-column prop="manualMerchantName" label="成交回收商" align="center">
            <template slot-scope="scope">
              {{ scope.row.manualMerchantName }}
              <el-tag type="danger" v-if="scope.row.ifMMerchant" effect="dark" size="mini">映射商家</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="mappingMiddleNum" label="映射商家" align="center">
            <template slot-scope="scope">
              <el-button @click="openStoreList({
                ...scope.row,
                isMappingQuote: true
              })" style="text-decoration: underline;cursor: pointer;color: orange;" type="text">{{
                scope.row.mappingMiddleNum
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>

    <!-- pagination -->
    <div style="display: flex;justify-content: end;background-color: #fff;padding: 30px;">
      <el-pagination background :current-page="pageNum" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="total" @current-change="handleCurrentChange" />
    </div>

    <!-- 导出Excel dialog -->
    <el-dialog :close-on-click-modal="false" :width="`${600}px`" title="导出Excel" :visible="excelVisible"
      @close="excelClose">
      <h1 style="font-size: 18px;font-weight: 600;">选择订单范围</h1>
      <el-form ref="excelForm" :model="excelForm" :rules="excelRules" label-width="80px">
        <el-form-item label-width="1px" prop="radio">
          <el-radio v-model="excelForm.isMajorOrder" :label="1">仅导出主商户订单</el-radio>
          <el-radio v-model="excelForm.isMajorOrder" label="">导出主商户订单+从商户订单</el-radio>
        </el-form-item>
        <el-form-item label-width="5px">
          是否确认导出订单？
        </el-form-item>
        <el-form-item label="动态口令" prop="command">
          <el-input v-model="excelForm.command"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: end;padding: 10px;">
          <el-button @click="excelClose">取消</el-button>
          <el-button type="primary" @click="onExcelSubmit" :loading="downloadLoading">确定</el-button>
        </div>
      </el-form>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看旧机照片" :visible="imgShow" @close="imgClose"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div @click="chooseImages(0)" class="img-tips" :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
            旧机照片
          </div>
          <div v-if="this.DialogImgList[1].length > 0" @click="chooseImages(1)" class="img-tips"
            :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'">
            补拍照片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList[imgIndex].length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList[imgIndex].length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList[imgIndex]">
              <el-carousel trigger="click" height="80vh" v-if="imgShow" @change="getindex">
                <el-carousel-item v-for="item in this.DialogImgList[this.imgIndex]" :key="item.imgNo">
                  <div class="sec_img">
                    <img :src="item.img" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :width="`80%`" title="查看参与报价回收商" :visible="storeShow" @close="storeClose"
      top="1%">
      <div class="img-box">
        <div class="noteLayout">
          <p class="lv_fc_red" style="margin-bottom: 10px">
            说明：若该门店商户预留差异基金，则门店所看到的报价金额需加上差异基金才是商户的初始报价
          </p>
          <div>
            <el-button type="danger" size="mini" plain :loading="expButtonLoading" v-if="isShowExpButton"
              @click="openNegotiatePriceDia">申请议价</el-button>
            <el-button type="warning" size="mini" plain @click="handleConfigColumns">配置列数据</el-button>
            <el-button v-if="quotePriceData.length != 0" type="text" @click="onQuotePrice">
              已邀请{{ quotePriceData.length }}家外部商家报价>
            </el-button>
          </div>
        </div>
        <GlobalForm ref="storeFormItemList" :form-item-list="storeFormItemList" :initData="{
          isMappingQuote: true,
          recycleMerchantName: ''
        }" :inline="true" :labelWidth="80" round @handleConfirm="storeHandleConfirm" confirmBtnName="查询"></GlobalForm>

        <div class="table_list">
          <GlobalTable ref="GlobalTable" v-loading="storeLoading" v-if="configRefresh" :columns="storeColumns"
            :data="storeList" :isPagination="false" max-height="700">
            <el-table-column slot="recycleMerchantName" label="报价商家" align="center" width="200">
              <template v-slot="{ row }">
                <el-tag v-if="row.recycleMerchantName == merchantName" size="mini" type="danger" effect="dark"
                  style="margin-right: 10px">
                  成交
                </el-tag>

                <span>{{ row.recycleMerchantName }}</span>
                <el-tag v-if="
                  row.isStandardRecycleMerchant &&
                  row.isStandardRecycleMerchant !== '--'
                " size="mini" type="warning" style="margin-left: 10px">虚拟基数</el-tag>
                <div>
                  <div style="
                      background: rgb(245, 245, 255);
                      border-radius: 4px;
                      padding: 0px 8px;
                      margin-top: 4px;
                      display: inline-block;
                    " v-if="
                      row.virtualName &&
                      baoPricestate == '00' &&
                      row.virtualName !== '--'
                    ">
                    {{ row.virtualName }}
                  </div>
                </div>
                <div>
                  <el-tag v-if="
                    row.isMapping" size="mini" type="danger" effect="dark" style="margin-right: 10px">
                    映射商家
                  </el-tag>
                  <el-tag v-if="
                    row.isFixHighQuote &&
                    row.recycleMerchantName != merchantName &&
                    row.isFixHighQuote != '--'
                  " size="mini" type="warning" effect="dark" style="margin-right: 10px">
                    首次取价
                  </el-tag>
                  <el-tag v-if="
                    row.isFixExpPrice &&
                    row.recycleMerchantName != merchantName &&
                    row.isFixExpPrice != '--'
                  " size="mini" type="warning" effect="dark">
                    议价取价
                  </el-tag>
                  <el-tag v-if="row.isAddPrice && row.isAddPrice != '--'" size="mini" type="success" effect="dark">
                    平台加价
                  </el-tag>
                </div>
                <div class="isdeal1" v-if="row.isOutMerchant == true">外部</div>
              </template>
            </el-table-column>
            <el-table-column slot="originalQuotePrice" label="报价金额（含差异基金）" align="center" min-width="100">
              <template slot-scope="{ row }">
                {{ row.originalQuotePrice }}
                <div v-if="row.isMockQuoteOpen">
                  虚拟报价：<span class="price">¥{{ row.mkOriginalQuotePrice }}</span>
                </div>
                <!--添加判断条件非老年机-->
                <div
                  v-if="row.isAutoQuote && row.isAutoQuote !== '--' && row.originalQuotePrice != '--' && row.originalQuotePrice > 0 && row.outType !== 'lb' && row.outType !== 'lb2' && row.orderLowView == '--' && !isElderlyMachine"
                  style="color:#FFAF29;text-decoration: underline;cursor: pointer;" @click="seeAutoQuote">查看</div>
                <!--以下查看显示规则为:低端机的自动报价 -->
                <div v-if="row.orderLowView && row.orderLowView !== '--'"
                  style="color:#FFAF29;text-decoration: underline;cursor: pointer;" @click="seeAutoQuoteDetail(row)">查看
                </div>
                <!--以下查看显示规则为:功能机老年机的自动报价 -->
                <div v-if="isElderlyMachine && isElderlyMachine !== '--' && row.isAutoQuote && row.isAutoQuote !== '--'"
                  style="color:#FFAF29;text-decoration: underline;cursor: pointer;" @click="seeLowDetail(row)">查看</div>
                <div v-if="row.isExamineQuote === true"
                  style="color:#0981FF;text-decoration: underline;cursor: pointer;" @click="openQuoteInfo(row)">审单报价详情
                </div>
                <div v-if="row.isQuoterQuick === true" style="color:#0981FF;text-decoration: underline;cursor: pointer;"
                  @click="openQuoteInfo(row)">快捷报价详情</div>

                  <div v-if="row.isRiskQuote == true" 
                  style="color:#FFAF29;text-decoration: underline;cursor: pointer;" @click="autoQuoteDetail = row,autoQuoteDetailShow = true">查看
                </div>
              </template>
            </el-table-column>
            <el-table-column slot="quotePrice" label="报价金额" align="center">
              <template scope="{ row }">
                {{ row.quotePrice }}
                <p v-if="row.isMockQuoteOpen">
                  虚拟报价：<span class="price">¥{{ row.mkQuotePrice }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column width="150" slot="staffName" label="报价人" align="center">
              <template scope="{ row }">
                <template v-if="row.isMockQuoteOpen">
                  {{ row.mkStaffName }}
                  <span v-if="
                    row.mkQuoteStaffPhone && row.mkQuoteStaffPhone != '--'
                  ">- {{ row.mkQuoteStaffPhone }}</span>
                  <span v-if="
                    row.mkQuotePositionType && row.mkQuotePositionType != '--'
                  ">-
                    {{
                      row.mkQuoteIsMajor === true
                        ? "创建人"
                        : row.mkQuotePositionType == "01"
                          ? "子账号"
                          : row.mkQuotePositionType == "02"
                            ? "报价师"
                            : "--"
                    }}</span>
                </template>
                <template v-else>
                  {{ row.staffName }}
                  <span v-if="row.staffMobile && row.staffMobile != '--'">- {{ row.staffMobile }}</span>
                  <span v-if="row.staffType && row.staffType != '--'">（{{ row.staffType }}）</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column slot="quoteNum" label="报价次数" align="center">
              <template scope="{ row }">
                <span v-if="row.quoteNum != '--' && row.quoteNum != 0" style="
                    text-decoration: underline;
                    cursor: pointer;
                    color: #0981ff;
                  " @click="Bargain(row, 'config')">{{ row.quoteNum }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column slot="state" label="报价状态" align="center">
              <template scope="{ row }">
                <span>{{
                  row.state == "00-0"
                    ? "待报价"
                    : row.state == "00-1"
                      ? "报价中"
                      : row.state == "00-2"
                        ? "已报价"
                        : row.state == "01"
                          ? "已确认"
                          : row.state == "10" && row.exclusiveCancelTime != "--"
                            ? `取消抢单${row.exclusiveCancelTime}`
                            : "交易取消"
                }}</span>
                <p v-if="row.isMockQuoteOpen && row.mkQuoteState == '01'">
                  <span class="price">虚拟报价</span>
                </p>
              </template>
            </el-table-column>
            <!-- <el-table-column slot="isMappingQuote" label="是否映射报价" align="center">
              <template scope="{ row }">
                {{ row.isMappingQuote?'是':'否' }}

              </template>
            </el-table-column> -->
            <!-- <el-table-column slot="isNiceDevice" width="100" label="是否标记靓机" align="center">
              <template scope="{ row }">
                <span>{{ row.isNiceDevice == true ? "是" : "否" }}</span>
              </template>
            </el-table-column> -->
            <el-table-column slot="quoteNote" label="报价备注" align="center">
              <template scope="{ row }">
                <el-tooltip v-if="row.quoteNote != '--'" class="item" effect="dark"
                  :content="row.quoteNote == '--' ? '' : row.quoteNote" placement="bottom">
                  <span class="quoteNotecss">{{ row.quoteNote }}</span>
                </el-tooltip>

                <span v-else>{{ row.quoteNote }}</span>
              </template>
            </el-table-column>
            <el-table-column slot="diffFundPrice" label="差异基金" align="center">
              <template scope="{ row }">
                {{ row.diffFundPrice }}
                <p v-if="row.isMockQuoteOpen">
                  虚拟：<span class="price">{{ row.mkDiffFundPrice }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column slot="quoteChannelServerFee" width="100" label="渠道服务费" align="center">
              <template scope="{ row }">
                {{ row.quoteChannelServerFee }}
                <div v-if="
                  row.quoteChannelServerFee &&
                  row.quoteChannelServerFee != '--'
                " style="color: red">
                  {{ row.matchServerFeeOnline == "01" ? "线上" : "线下" }}
                </div>
                <p v-if="row.isMockQuoteOpen">
                  虚拟：<span class="price">{{ row.mkChannelServerFee }}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column slot="commission" width="100" label="外部预扣手续费" align="center">
              <template scope="{ row }">
                <span v-if="row.commission">{{ row.commission || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column slot="limitExclusiveLength" label="限时报价" align="center">
              <template scope="{ row }">
                <span>{{
                  row.limitExclusiveLength == "--"
                    ? "不限制"
                    : row.limitExclusiveLength + "分钟"
                }}</span>
                <el-tag v-if="row.isBidding === true" size="mini" type="danger" effect="dark">
                  已中标
                </el-tag>
              </template>
            </el-table-column>
          </GlobalTable>
          <!-- </el-table> -->
        </div>
      </div>
    </el-dialog>

    <el-dialog title="申请议价" :visible.sync="negotiatePriceVisible" :close-on-click-modal="false" top="50px" width="700px"
      @closed="negotiatePriceClose">
      <div class="negotiate-price-box" v-loading="expButtonLoading">
        <div class="negotiate-price-item">
          <span class="label-title"><span class="label-must">*</span>申请加价金额</span>
          <div>
            <div>
              <el-input :disabled="isSavePrice" style="width:271px;margin-right: 10px;" size="small"
                v-model="negotiatePriceForm.price" placeholder="请输入加价金额，小于999的正整数"
                @input="negotiatePriceInput"></el-input>
              <el-button size="small" :type="isSavePrice ? 'danger' : 'success'" :loading="savePriceBtnLoading"
                @click="savePrice">{{ isSavePrice ? '修改' : '保存' }}</el-button>
            </div>
            <div style="display: flex;margin-top: 10px;">
              <el-tag style="cursor: pointer;margin-right:5px;" v-for="item in priceArr" :key="item" effect="plain"
                @click="selectPrice(item)">
                {{ item }}
              </el-tag>
            </div>
          </div>
        </div>
        <div class="negotiate-price-item mt-10">
          <span class="label-title">议价备注(非必填，提交后将展示给回收商)</span>
          <el-input style="width:370px;font-size: 12px" type="textarea" placeholder="请输入议价备注"
            v-model.trim="negotiatePriceForm.note" maxlength="200" show-word-limit>
          </el-input>
        </div>
        <div class="mt-20" v-if="expBeforeInfo && expBeforeInfo.computeDto">
          <div class="flex flex-jb">
            <span>发起议价商家：<span style="font-weight: bold">{{ expBeforeInfo.recycleMerchantName }}</span></span>
            <span>议价审批时长：<span style="font-weight: bold">{{ getTimes2(expBeforeInfo.platformExpSecond) }}</span></span>
          </div>
          <div class="price-content-item mt-10 flex">
            <div class="on-price-icon">当前</div>
            <div class="price-content-first">
              <p>{{ expBeforeInfo.quotePrice }}</p>
              <p>当前报价</p>
            </div>
            <div class="price-content-after" v-for="item in priceExplain" :key="item.key">
              <p>{{ expBeforeInfo.computeDto[item.key] }}</p>
              <p style="color: #666666">{{ item.text }}</p>
            </div>
            <div class="price-content-last">
              <p>{{ expBeforeInfo.computeDto.userShowPrice }}</p>
              <p style="color: #333333">用户成交价</p>
            </div>
          </div>
          <div class="price-content-item mt-10 flex">
            <div class="on-price-icon" style="background-color: #ff5757">申请议价</div>
            <template v-if="expectCompute">
              <div class="price-content-first" style="color:#ff5757">
                <p>{{ expectQuotePrice }}</p>
                <p>期望报价</p>
              </div>
              <div class="price-content-after" v-for="item in priceExplain" :key="item.key">
                <p>{{ expectCompute[item.key] }}</p>
                <p style="color: #666666">{{ item.text }}</p>
              </div>
              <div class="price-content-last" style="color:#ff5757">
                <p>{{ expectCompute.userShowPrice }}</p>
                <p style="color: #333333">期望用户成交价</p>
              </div>
            </template>
            <span v-else style="margin: auto">请先输入或选择加价金额并保存</span>
          </div>
        </div>
        <div class="negotiate-price-item mt-20" style="flex-direction: column">
          <span class="label-title" style="margin-right: 3px;line-height: 28px"><span
              class="label-must">*</span>上传沟通凭证（最多3张，内部使用）</span>
          <JudgementsList :is-reset="isResponsibilityReset" :source-data="negotiatePriceForm.voucherList"
            @dataChange="(v) => judgementsChange(v)" :assignmentData="assignmentData" state="00" />
          <p style="color: #ff5757;">请上传本次的沟通凭证（限3张内，大小不超过5M，格式为JPG或PNG）</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="negotiatePriceVisible = false">取消</el-button>
        <el-button type="primary" :loading="expApplyBtnLoading" @click="submitExpApply">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="配置列数据" :visible.sync="configShow" width="20%">
      <GlobalTable ref="multipleTable" :columns="configList" :data="configData" :maxHeight="500" :isPagination="false"
        @handleSelect="handleSelectionChange">
        <el-table-column :reserve-selection="true" type="selection" slot="checkColumn" align="center">
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelConfig">取 消</el-button>
        <el-button type="primary" @click="handleConfig">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 外部商家报价 -->
    <el-dialog title="外部商家报价" :visible.sync="quotePriceShow" width="60%">
      <div class="command">
        <div>
          平台最高显示价：{{ outMerchant.maxQuoteSecretPrice }}
          <span v-if="outMerchant.maxMerchantName">（{{ outMerchant.maxMerchantName }}）</span>
        </div>
        <div style="margin-left: 50px">
          外部商家添加门槛：显示价需比平台<span style="color: #ff687b">高{{ outMerchant.quoteCondition || 0 }}元</span>
        </div>
      </div>
      <GlobalTable :loading="quoteOperateLoading" ref="quotePriceTable" :columns="quotePriceList" :data="quotePriceData"
        :maxHeight="500" :isPagination="false">
        <el-table-column label="商户名称" slot="recycleMerchantName" align="center">
          <template slot-scope="{ row }">
            <el-tooltip v-if="row.recycleMerchantName != ''" class="item" effect="dark"
              :content="row.recycleMerchantName" placement="top">
              <div class="quoteNotecss">{{ row.recycleMerchantName }}</div>
            </el-tooltip>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="原始报价" slot="originalQuotePrice" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.originalQuotePrice">
              {{ row.originalQuotePrice }}
              <span v-if="row.commission">（含{{ row.commission }}元手续费）</span>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="报价金额" slot="quotePrice" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.quotePrice || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店显示价" slot="quoteSecretPrice" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.quoteSecretPrice || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报价时间" slot="quoteTime" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.quoteTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="报价单状态" slot="state" align="center">
          <template slot-scope="{ row }">
            <!-- 
                第一行：已报价 （state = 00-2，01），（state = 00-0，00-1）拒绝报价（isRejectQuote=true） 
                第二行：已添加竞价（isJoinQuote = true），
                        报价不足未添加 （isJoinQuote = false，isUpCnd = false），
                        待补拍 （reApplyState=00），
            -->
            <div>
              {{
                row.isRejectQuote == true
                  ? "拒绝报价"
                  : row.state == "00-2" || row.state == "01"
                    ? "已报价"
                    : row.state == "00-0" || row.state == "00-1"
                      ? "已邀请未报价"
                      : row.state == "10"
                        ? "交易取消"
                        : "--"
              }}
            </div>
            <!-- 已邀请未报价 -->
            <div v-if="row.state == '00-0' || row.state == '00-1'">
              <span v-if="row.reApplyState == '00'">(待补拍)</span>
              <span v-if="row.reApplyState == '01'">(已补拍)</span>
            </div>
            <!-- 已报价 -->
            <div v-if="row.state == '00-2' || row.state == '01'">
              <span v-if="row.reApplyState == '00'">(待补拍)</span>
              <span v-if="row.isJoinQuote == true">(已添加竞价)</span>
              <span v-if="row.isJoinQuote == false && row.isUpCnd == false">(报价不足未添加)</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="付款状态" slot="outPayState" align="center">
          <template slot-scope="{ row }">
            <div v-if="
              row.outPayRefundState != '00' && row.outPayRefundState != null
            ">
              {{
                row.outPayState == "01"
                  ? "退款中"
                  : row.outPayState == "02"
                    ? "退款完成"
                    : row.outPayState == "03"
                      ? "退款失败"
                      : "--"
              }}
            </div>
            <div v-else-if="row.outPayRefundState == '00'">
              {{
                row.outPayState == "00"
                  ? "未发起"
                  : row.outPayState == "01"
                    ? "付款中"
                    : row.outPayState == "02"
                      ? "已付款"
                      : "--"
              }}
            </div>
            <div v-else>--</div>
            <div class="text-down" v-if="row.outPayState || row.outPayRefundState" @click="viewPayer(row)">
              查看付款信息
            </div>
          </template>
        </el-table-column>
        <el-table-column label="付款方" slot="outPayChannel" align="center">
          <template slot-scope="{ row }">
            <span>{{
              row.outPayChannel == "Store"
                ? "店员付款"
                : row.outPayChannel == "Merchant"
                  ? "回收商付款"
                  : "--"
            }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quotePriceShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 外部商家报价 -->
    <el-dialog title="付款信息" :visible.sync="paymentShow" width="30%">
      <div class="detail-price-box">
        <div>
          <div class="outPay">
            <span class="outPay_title">付款信息：</span>
            <div class="outPay_tag">
              {{ payInfo.outPayChannel == "Store" ? "店员付款" : "回收商付款" }}
            </div>
          </div>
          <div class="outPay_info">
            <div>
              付款人：{{ payInfo.outPayStaffName }} -
              {{ payInfo.outPayStaffMobile }}
              <span v-if="payInfo.outPayStaffType">（{{ payInfo.outPayStaffType }}）</span>
            </div>
            <div>付款时间：{{ payInfo.outPayTime || "--" }}</div>
            <div>微信交易单号：{{ payInfo.outPayNo }}</div>
          </div>
        </div>
        <div class="mt-20" v-if="payInfo.outPayRefundTime || payInfo.outPayRefundNo">
          <div class="outPay">
            <span class="outPay_title">退款信息：</span>
          </div>
          <div class="outPay_info1">
            <!-- <div>退回账户：{{ payInfo.test000 }}</div> -->
            <div>退款时间：{{ payInfo.outPayRefundTime }}</div>
            <div>微信退款单号：{{ payInfo.outPayRefundNo }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paymentShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="自动报价明细" :visible.sync="autoInfoVisible" :close-on-click-modal="false" width="400px">
      <div class="auto-info-dia" v-loading="autoInfoDiaLoading">
        <div class="flex auto-info-dia-tip">
          <p :class="orderAutoInfo.source === '00' ? 'general-blue' : 'general-yellow'">{{ orderAutoInfo.source ===
            '00' ? '通用机型自动报价' : '指定机型自动报价' }}</p>
          <div class="status_grd" :class="orderAutoInfo.isHighRisk ? 'abnormal' : ''">
            {{ orderAutoInfo.isHighRisk ? '已触发高风险' : '未触发高风险' }}</div>
        </div>
        <p v-if="orderAutoInfo.source === '01'">报价方式：{{ orderAutoInfo.quoteWay == '00' ? '自定义系数' : '自定义报价' }}</p>
        <p v-if="orderAutoInfo.quoteWay == '00'">
          <span v-if="orderAutoInfo.calcStandard === '00'">分毫靓机价：{{ orderAutoInfo.initNicePrice }}元</span>
          <span v-else>{{ orderAutoInfo.source === '00' ? '预估价' : autoInfoOutType ===
            'honor' ? '分毫靓机价' : '预估价' }}：{{ orderAutoInfo.estimatedPrice }}元</span>
        </p>
        <p v-if="orderAutoInfo.quoteWay == '00'">计算系数：{{ orderAutoInfo.usePriceOrRate }}（{{
          orderAutoInfo.autoQuoteExplain
        }}）
        </p>
        <p>自动报价金额：{{ orderAutoInfo.autoQuotePrice }}元<span
            v-if="orderAutoInfo.source === '01' && orderAutoInfo.quoteWay == '01'">（{{ orderAutoInfo.autoQuoteExplain
            }}）</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoInfoVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--新增查看报价明细-->
    <el-dialog title="自动报价明细" :visible.sync="autoInfoVisibleDetail" :close-on-click-modal="false" width="400px">
      <div class="auto-info-dia" v-loading="autoInfoDiaDetailLoading">
        <p style="font-weight: bold;">低端机自动报价</p>
        <p>故障项：<span style="color: #0981ff;">{{ orderLowView.optionName }}</span></p>
        <p>自动报价金额：<span style="color: #0981ff;">{{ orderLowView.price }}元</span></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoInfoVisibleDetail = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--新增查看功能机老年机报价明细-->
    <el-dialog title="自动报价明细" :visible.sync="lowInfoVisibleDetail" :close-on-click-modal="false" width="400px">
      <div class="auto-info-dia" v-loading="autoInfoDiaDetailLoading">
        <p style="font-weight: bold;">功能机老年机自动报价</p>
        <p>自动报价金额：<span style="color: #0981ff;">{{ lowinfo }}元</span></p>
        <!--新增单价-->
        <p>单台报价:{{ lowprice }}元(共{{ lownum }}台)</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="lowInfoVisibleDetail = false">关闭</el-button>
      </span>
    </el-dialog>

    <AmountDetailDia v-if="amountDetailDiaShow" :dialogVisible="amountDetailDiaShow" :merchantId="rowItemMerchantId"
      :type="amountDetailDiaType" :orderNo="orderNo" @close="amountDetailDiaShow = false" />


    <el-dialog :close-on-click-modal="false" :width="`${1300}px`" title="查看报价记录" :visible="viewrecords"
      @close="viewrecordsClose" top="15%" bottom="10%">
      <div class="table_list autoshow" style="padding-bottom: 20px">
        <el-table :data="getUpdatedQuoteLog" max-height="300" border style="width: 100%" id="updatedOrder">
          <el-table-column prop="rank" width="70" label="报价次序" align="center"></el-table-column>
          <el-table-column prop="quoteTime" width="160" label="报价时间" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.quoteTime }}</span>
              <el-tag v-if="
                row.isMappingQuote" size="mini" type="danger" effect="dark" style="margin-right: 10px">
                映射报价
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="报价人" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.exclusiveQuoterName }}-{{
                row.isMajor
                  ? "创建人"
                  : row.positionType == "01"
                    ? "子账号"
                    : "报价师"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" label="报价金额" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.quotePrice }}</span>
              <div>
                <el-tag type="danger" size="small" effect="plain" v-if="row.isInside">内部加价</el-tag>
              </div>
              <p v-if="row.isMockQuoteOpen">
                虚拟报价：<span class="price">¥{{ row.mkQuotePrice }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="报价备注" align="center">
            <template slot-scope="{ row }">
              <el-tooltip v-if="row.quoteNote" class="item" effect="dark" :content="row.quoteNote" placement="top">
                <div class="quoteNotecss">
                  {{ row.quoteNote }}
                </div>
              </el-tooltip>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="是否为映射报价" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.isMappingQuote" style="color: red;">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <!-- 新增 -->
          <el-table-column prop="originalQuotePrice" width="100" label="报价金额（含差异基金）" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.originalQuotePrice }}</span>
              <p v-if="row.isMockQuoteOpen">
                虚拟报价：<span class="price">¥{{ row.mkOriginalQuotePrice }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="diffFundPrice" width="100" label="差异基金" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.diffFundPrice }}</span>
              <p v-if="row.isMockQuoteOpen">
                虚拟：<span class="price">{{ row.mkDiffFundPrice }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="quoteChannelServerFee" width="100" label="渠道服务费" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.quoteChannelServerFee }}</span>
              <p v-if="row.isMockQuoteOpen">
                虚拟：<span class="price">{{ row.mkChannelServerFee }}</span>
              </p>
            </template>
          </el-table-column>
        </el-table>
        <div style="color: #0981ff; font-size: 16px; margin: 20px 0" v-if="remakeQuoteLog && remakeQuoteLog.length">
          补拍后报价记录
        </div>
        <el-table v-if="remakeQuoteLog && remakeQuoteLog.length" :data="remakeQuoteLog" max-height="300" border
          style="width: 100%" id="remakeOrder">
          <el-table-column prop="rank" width="70" label="报价次序" align="center"></el-table-column>
          <el-table-column prop="remakeTime" width="100" label="补拍时间" align="center"></el-table-column>
          <el-table-column prop="quoteTime" width="100" label="报价时间" align="center"></el-table-column>
          <el-table-column label="报价人" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.exclusiveQuoterName }}-{{
                row.isMajor
                  ? "创建人"
                  : row.positionType == "01"
                    ? "子账号"
                    : "报价师"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" label="报价金额" align="center">
            <template slot-scope="{ row }">
              <span>￥{{ row.quotePrice }}</span>
              <div>
                <el-tag type="danger" size="small" effect="plain" v-if="row.isInside">内部加价</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报价备注" align="center">
            <template slot-scope="{ row }">
              <el-tooltip v-if="row.quoteNote" class="item" effect="dark" :content="row.quoteNote" placement="top">
                <div class="quoteNotecss">
                  {{ row.quoteNote }}
                </div>
              </el-tooltip>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- 新增 -->
          <el-table-column prop="originalQuotePrice" width="100" label="报价金额（含差异基金）" align="center"></el-table-column>
          <el-table-column prop="diffFundPrice" width="100" label="差异基金" align="center"></el-table-column>
          <el-table-column prop="quoteChannelServerFee" width="100" label="渠道服务费" align="center"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    
    <el-dialog title="自动报价明细" @close="autoQuoteDetailShow = false,autoQuoteDetail = {}" :visible.sync="autoQuoteDetailShow" :close-on-click-modal="false" width="400px">
      <div class="auto-info-dia" style="margin-bottom: 20px;">
       <div style="color: #FF687B;">该订单已触发黑名单门店/店员，默认报极低价</div>
      </div>
      <div>
        自动报价：{{  autoQuoteDetail.riskQuotePrice}}元
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoQuoteDetailShow = false,autoQuoteDetail = {}">关闭</el-button>
      </span>
    </el-dialog>
    <DialogDownLoad v-if="isShowDownloadSuccess" :isShowDownloadSuccess="isShowDownloadSuccess" @close="closebillDown"
      @config="billconfig"></DialogDownLoad>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { http } from "@/utils/request/masterSlaveMerchantOrder";
import AmountDetailDia from "../componets/AmountDetailDia.vue";
import JudgementsList from "../../payment/componets/JudgementsList.vue";
import DialogDownLoad from "@/components/global/components/DialogDownLoad.vue"
import moment from "moment";


export default {
  components: {
    AmountDetailDia,
    JudgementsList,
    DialogDownLoad
  },
  data() {
    return {
      pageNum: 1,
      total: 1,
      orderTableList: [],
      loading: false,
      downloadLoading: false,
      excelVisible: false,
      excelForm: {
        isMajorOrder: 1,
        command: ''
      },
      excelRules: {
        isMajorOrder: [
          { required: true, message: '请选择选择订单范围', trigger: 'change' }
        ],
        command: [
          { required: true, message: '请输入动态口令', trigger: 'change' }
        ],
      },
      imgShow: false,
      imgIndex: 0,
      imgShowOnly: false,
      DialogImgList: [[], []],
      imgShowIndex: 0,

      storeShow: false,
      storeList: [],
      isElderlyMachine: '',
      baoPricestate: '',
      merchantName: '',
      orderNo: '',
      autoInfoOutType: '',
      isShowExpButton: false, //是否显示议价按钮，dev-2.5.1屏蔽
      storeQueryRow: {
        recycleMerchantName: '',
        isMappingQuote: true
      },
      expButtonLoading: false,
      isResponsibilityReset: false,
      negotiatePriceVisible: false,
      expBeforeInfo: {},
      configData: [
        {
          prop: "recycleMerchantName",
          label: "报价商家",
        },
        {
          prop: "originalQuotePrice",
          label: "报价金额（含差异基金）",
        },
        {
          prop: "quoteSecretPrice",
          label: "用户成交价",
        },
        {
          prop: "exclusiveTime",
          label: "抢单时间",
        },
        {
          prop: "quoteTime",
          label: "最新报价时间",
        },
        {
          prop: "staffName",
          label: "报价人",
        },
        {
          prop: "quoteNum",
          label: "报价次数",
        },
        {
          prop: "state",
          label: "报价状态",
        },
        {
          prop: "isNiceDevice",
          label: "是否标记靓机",
        },
        {
          prop: "quoteNote",
          label: "报价备注",
        },
        {
          prop: "quotePrice",
          label: "报价金额",
        },
        {
          prop: "diffFundPrice",
          label: "差异基金",
        },
        {
          prop: "quoteChannelServerFee",
          label: "渠道服务费",
        },
        {
          prop: "commission",
          label: "外部预扣手续费",
        },
        {
          prop: "limitExclusiveLength",
          label: "限时报价时长",
        },
      ],
      configShow: false,
      quotePriceData: [],
      quotePriceShow: false,
      quoteOperateLoading: false,
      outMerchant: {
        maxMerchantName: "",
        maxQuoteSecretPrice: 0,
        quoteCondition: 0,
      },
      storeFormItemList: [
        {
          key: "recycleMerchantName",
          type: "input",
          labelName: "报价商家",
          placeholder: "请输入报价商家",

        },
        {
          key: "isMappingQuote",
          type: "select",
          labelName: "是否为映射商家",
          placeholder: "请选择是否为映射商家",
          lableWidth: '130px',
          option: [
            {
              value: null,
              label: "全部",
            },
            {
              value: true,
              label: "是",
            },
            {
              value: false,
              label: "否",
            },
          ],
        },
      ],
      storeLoading: false,
      configRefresh: true,
      storeColumns: [
        { slotName: "recycleMerchantName" }, //报价商家
        // { label: "报价金额（含差异基金）", prop: "originalQuotePrice" }, //报价金额
        { slotName: "originalQuotePrice" }, //报价金额
        // { label: "报价金额", prop: "quotePrice" }, //报价金额
        { slotName: "quotePrice" }, //报价金额
        { label: "用户成交价", prop: "quoteSecretPrice" }, //用户成交价
        { label: "抢单时间", prop: "exclusiveTime" }, //抢单时间
        { label: "最新报价时间", prop: "quoteTime" }, //最新报价时间
        { slotName: "staffName" }, //报价人
        { slotName: "quoteNum" }, //报价次数
        { slotName: "state" }, //报价状态
        // { slotName: "isMappingQuote" }, //是否映射报价
        // { slotName: "isNiceDevice" }, //是否标记靓机
        { slotName: "quoteNote" }, //报价备注
        // { label: "差异基金", prop: "diffFundPrice" }, //差异基金
        { slotName: "diffFundPrice" }, //差异基金
        { slotName: "quoteChannelServerFee" }, //渠道服务费
        { slotName: "commission" }, //外部预扣手续费
        { slotName: "limitExclusiveLength" }, //限时报价
      ],
      autoInfoDiaLoading: false,
      orderAutoInfo: {},
      autoInfoVisible: false,
      autoInfoVisibleDetail: false,//查看自动报价明细
      autoInfoDiaDetailLoading: false,
      orderLowView: {},//低端自动报价
      lowInfoVisibleDetail: false,
      lowinfo: "",
      lowprice: "",
      lownum: "",
      amountDetailDiaShow: false,
      rowItemMerchantId: "",
      amountDetailDiaType: "",
      getUpdatedQuoteLog: [],
      remakeQuoteLog: [],
      isSavePrice: false,
      negotiatePriceForm: {
        price: "",
        note: "",
        voucherList: [],
      },
      savePriceBtnLoading: false,
      priceArr: [5, 10, 15, 20, 30, 40, 50],
      assignmentData: [],
      expApplyBtnLoading: false,
      configList: [
        { label: "列名", prop: "label" },
        { slotName: "checkColumn" }, //显示
      ],
      configColumnsArr: [],
      quotePriceList: [
        { slotName: "recycleMerchantName" }, //商户名称
        // { label: "商户名称", prop: "recycleMerchantName" },
        { label: "创建人", prop: "createStaffName" },
        { label: "联系电话", prop: "createStaffPhone" },
        { slotName: "originalQuotePrice" },
        // { label: "门店显示价", prop: "quoteSecretPrice" },
        // { label: "报价时间", prop: "quoteTime" },
        { slotName: "quotePrice" }, //报价金额
        { slotName: "quoteSecretPrice" }, //门店显示价
        { slotName: "quoteTime" }, // 报价时间
        { slotName: "state" }, //报价单状态
        { slotName: "outPayState" }, //付款状态
        { slotName: "outPayChannel" }, //付款方
      ],
      viewrecords: false,
      middleColumns: [],
      paymentShow: false,
      payInfo: { outPayStaffMobile: "" },
      isShowDownloadSuccess: false,
            autoQuoteDetailShow:false,
      autoQuoteDetail:{},
    };
  },
  created() {
    this.handleCurrentChange()
    this.middleColumns = [...this.storeColumns];

  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newval) {
      console.log(newval, "SeachParamsSeachParams");
      this.pageNum = 1
      this.handleCurrentChange();
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.isMajorOrder) {
        return 'orangeRow';
      }
    },
    handleCurrentChange(val) {
      console.log(val, 111);

      // this.loading = true;
      console.log('this.pageNum', this.pageNum);
      this.pageNum = val
      http.GRList({
        pageNum: this.pageNum,
        pageSize: 10,
        ...this.SeachParams,
      }).then((res) => {
        console.log('res.data.records', res.data.records);
        this.total = res.data.total
        this.orderTableList = res.data.records.map((le) => {
          return {
            ...le,
            // orderGroupRelationshipDtos: le.orderGroupRelationshipDtos.map((le) => {
            //   return {
            //     ...le,
            //     orderTime: moment(le.orderTime).format("YYYY-MM-DD"),
            //   }
            // }),
            mainChannelNames: le.mainChannelNames?.join('、'),
            mainChannelNameFXGet: le.mainChannelNameFXGet && le.mainChannelNameFXGet[0] ? le.mainChannelNameFXGet?.join('、') : '暂无'
          }
        })

        console.log('this.orderTableList', this.orderTableList);

      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    truncateString(str, maxLength) {
      if (str.length <= maxLength) {
        return str;
      }
      return str.slice(0, maxLength) + '...';
    },
    //导表
    exportExcel() {
      this.excelVisible = true
    },
    excelClose() {
      this.$refs['excelForm'].resetFields();
      this.excelVisible = false
    },
    onExcelSubmit() {
      this.$refs['excelForm'].validate((valid) => {
        if (valid) {
          const params = {
            ...this.SeachParams,
            ...this.excelForm
          };
          this.downloadLoading = true;
          http.GRExcel(params).then((res) => {
            console.log(res);
            const content = res;
            const blob = new Blob([content]);
            let reader = new FileReader(); // 创建读取文件对象
            reader.addEventListener("loadend", () => {
              try {
                let data = JSON.parse(reader.result);
                if (data.code === 0) {
                  this.$message.error(data.msg || "导出失败");
                  this.isShowDownloadSuccess = false;
                }
                else {
                  this.isShowDownloadSuccess = true
                }
              } catch (err) {
                const fileName = "关联订单记录.xlsx";
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              }
            });
            reader.readAsText(blob, "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
            this.downloadLoading = false;
            this.excelClose()
          })
            .catch((err) => {
              console.log(err);
              this.downloadLoading = false;
              this.excelClose()

            })
        } else {
          return false;
        }
      });

    },

    jumpToClick(item, type) {
      console.log(111, item, type);
      if (type == 'chuanhao') {
        const { imei } = item
        const { href } = this.$router.resolve({
          path: "/RecallOrder/index",
          query: {
            imei: imei,
            fromMasterSlaveMerchantOrder: true
          },
        });
        window.open(href, "_blank");
      } else {
        const { orderNoMajor, orderNo } = item
        const { href } = this.$router.resolve({
          path: "/RecallOrder/Details",
          query: {
            type: "edit",
            id: orderNoMajor || orderNo,
          },
        });
        window.open(href, "_blank");
      }

    },
    openImgBox(row) {
      console.log(row);
      this.imgShow = true;
      this.DialogImgList = [
        [...(row.images == "--" || !row.images ? [] : row.images)],
        [...(row.reImages == "--" || !row.reImages ? [] : row.reImages)],
      ];
      console.log(this.DialogImgList);
    },
    chooseImages(e) {
      if (e == 0) {
        this.imgIndex = 0;
        this.imgShowOnly = true;
      }
      if (e == 1) {
        this.imgIndex = 1;
        this.imgShowOnly = false;
      }
    },
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
    },

    // 所有不为真的第一层数据重置为--
    handleData(param) {
      for (const key in param) {
        if (Object.prototype.toString.call(param[key]) === "[object Object]") {
          this.handleData(param[key]);
        } else if (
          (param[key] === null ||
            param[key] === undefined ||
            param[key] === "") && key !== 'isMarkImeiPull'   //不处理成--
        ) {
          param[key] = "--";
        }
      }
      return param;
    },
    storeHandleConfirm(e) {
      console.log(e, 111);
      this.openStoreList({
        ...this.storeQueryRow,
        ...e
      })
    },
    // 报价商家弹窗
    openStoreList(e) {
      console.log(e, 99999);
      this.isElderlyMachine = e.isElderlyMachine
      this.baoPricestate = e.state;
      this.merchantName = e.merchantName;
      this.orderNo = e.orderNo;
      this.autoInfoOutType = e.outType;
      this.isShowExpButton = e.isShowExpButton;
      this.storeQueryRow = e
      this.storeLoading = true
      const { orderNo, isMappingQuote, recycleMerchantName } = e
      _api.orderStoreList({
        orderNo,
        isMappingQuote: isMappingQuote,
        recycleMerchantName: recycleMerchantName ? recycleMerchantName : '',
      }).then((res) => {
        if (res.code == 1) {
          for (const item of res.data) {
            this.handleData(item);
          }
          this.storeList = res.data;
        }
        this.storeLoading = false
      });
      this.toggleSelection();
      this.handleOutConfigColumns();
      this.lownum = e.phoneNum
      this.storeShow = true;
    },
    seeAutoQuote() {
      this.autoInfoDiaLoading = true
      _api.getOrderAutoInfo({ orderNo: this.orderNo }).then(res => {
        if (res.code === 1) {
          this.orderAutoInfo = res.data || {}
          this.autoInfoDiaLoading = false
        }
      })
      this.autoInfoVisible = true
    },
    //新增查看自动报价明细
    seeAutoQuoteDetail(row) {
      this.autoInfoDiaDetailLoading = true
      console.log(row, "row")
      this.orderLowView = row.orderLowView || {}
      this.autoInfoDiaDetailLoading = false
      this.autoInfoVisibleDetail = true
    },
    //查看功能机老年机
    seeLowDetail(row) {
      console.log(row, "row")
      this.lowInfoVisibleDetail = true
      this.lowinfo = row.originalQuotePrice
      this.lowprice = Math.round((row.originalQuotePrice / this.lownum) * row.originalQuotePrice) / row.originalQuotePrice;
    },
    openQuoteInfo(row) {
      this.amountDetailDiaShow = true
      this.amountDetailDiaType = row.isQuoterQuick === true ? '01' : '02'
      this.rowItemMerchantId = row.recycleMerchantId
      //2.5.3 如果是参考报价
      //if(){
      //this.referenceQuotationDetail=true
      // }

    },
    Bargain(row, column, cell, event) {
      console.log("@44@", row, column, cell, event);
      if (
        !(row.quoteNum == 0) &&
        !(row.quoteNum == "--") &&
        (column.property == "quoteNum" || column == "config")
      ) {
        console.log(row, "------------");
        // this.storeShow = false;
        this.viewrecords = true;
        _api
          .getUpdatedQuoteLog({
            merchantId: row.recycleMerchantId,
            orderNo: row.orderNo,
          })
          .then((res) => {
            console.log(res.data, "报价信息");
            this.getUpdatedQuoteLog = res.data.normal;
            this.remakeQuoteLog = res.data.remake;
          });
      }
    },
    viewrecordsClose() {
      this.Closingoffer = false;
      this.viewrecords = false;
      this.pricePushshow = false;
    },
    openNegotiatePriceDia() {
      this.isResponsibilityReset = false
      this.expButtonLoading = true
      _api.getOrderExpBeforeView({ orderNo: this.orderNo }).then(res => {
        this.negotiatePriceVisible = true
        this.expBeforeInfo = res.data
      }).finally(() => {
        this.expButtonLoading = false
      });
    },
    judgementsChange(v) {
      this.negotiatePriceForm.voucherList = v;
    },
    negotiatePriceInput(value) {
      // 只保留数字字符
      const num = value.replace(/[^0-9]/g, '');
      // 转换为整数
      const intValue = parseInt(num, 10);
      // 检查是否为有效的正整数
      if (!isNaN(intValue) && intValue > 0 && intValue <= 999) {
        this.negotiatePriceForm.price = intValue;
      } else if (intValue > 999) {
        this.negotiatePriceForm.price = 999
      } else {
        // 如果不符合条件，清空输入或设置为最后一个有效值
        this.negotiatePriceForm.price = '';
      }
    },
    selectPrice(item) {
      this.negotiatePriceForm.price = item
    },
    savePrice() {
      if (this.isSavePrice) {
        return this.isSavePrice = false
      }
      if (!this.negotiatePriceForm.price) {
        return this.$message.error('请输入加价金额')
      }
      this.expectQuotePrice = this.negotiatePriceForm.price + this.expBeforeInfo.quotePrice
      this.savePriceBtnLoading = true
      _api.quoteOrderPriceCompute2({ orderNo: this.orderNo, quotePrice: this.expectQuotePrice, merchantId: this.expBeforeInfo.recycleMerchantId }).then(res => {
        if (res.code === 1) {
          this.expectCompute = res.data
          console.log(this.expectCompute, 'this.expectCompute');

        }
        this.isSavePrice = true
      }).finally(() => {
        this.savePriceBtnLoading = false;
      });
    },
    submitExpApply() {
      if (!this.isSavePrice) {
        return this.$message.error('请先保存金额')
      }
      if (this.negotiatePriceForm.voucherList.filter((item) => !item.url).length > 0) {
        return this.$message.error("请上传凭证！");
      }
      let params = {
        orderNo: this.orderNo,
        recycleMerchantId: this.expBeforeInfo.recycleMerchantId,
        voucherList: this.negotiatePriceForm.voucherList.map(item => item.url),
        note: this.negotiatePriceForm.note,
        quotePrice: this.expectQuotePrice,
        addPrice: this.negotiatePriceForm.price,
      }
      this.expApplyBtnLoading = true
      _api.doOrderExpApply(params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '操作成功')
          this.negotiatePriceVisible = false
        }
      }).catch(() => {
        this.expButtonLoading = true
        this.isSavePrice = false
        this.negotiatePriceForm.price = ""
        this.expectCompute = null
        _api.getOrderExpBeforeView({ orderNo: this.orderNo }).then(res => {
          this.expBeforeInfo = res.data
        }).finally(() => {
          this.expButtonLoading = false
        });
      }).finally(() => {
        this.expApplyBtnLoading = false
      });
    },
    negotiatePriceClose() {
      this.negotiatePriceForm = {
        price: "",
        note: "",
        voucherList: [],
      }
      this.isResponsibilityReset = true
      this.expBeforeInfo = null
      this.expectCompute = null
      this.isSavePrice = false
    },
    // 列表信息回显
    toggleSelection() {
      this.configRefresh = false;
      _api.findColumns({ tableName: "参与报价回收商" }).then((res) => {
        this.storeColumns = this.middleColumns.filter((item) => {
          return res.data.some(
            (obj) =>
              obj.columnName === item.prop || obj.columnName === item.slotName
          );
        });
        // 解决问题：点击配置数据时，默认选项，其他什么都不选，直接确定而产生的数据为空的bug
        this.configColumnsArr = this.configData.filter((item) => {
          return res.data.some((obj) => obj.columnName === item.prop);
        });
        this.configRefresh = true;
      });
    },
    // 配置列按钮
    handleConfigColumns() {
      // this.toggleSelection()
      // 配置列数据回显
      _api.findColumns({ tableName: "参与报价回收商" }).then((res) => {
        res.data.forEach((item) => {
          this.$nextTick(() => {
            this.configData.find((obj) => {
              if (obj.prop == item.columnName) {
                this.$refs.multipleTable.$refs.tableGroup.toggleRowSelection(
                  obj,
                  true
                );
              }
            });
          });
        });
      });
      this.configShow = true;
    },
    // 重置配置列
    cancelConfig() {
      this.$refs.multipleTable.clearSelection();
      this.configColumnsArr = [];
    },
    // 确定
    handleConfig() {
      const transformedArr = this.configColumnsArr.map((obj) => {
        return {
          columnName: obj.prop, // 将prop属性值赋给columnName属性
        };
      });
      _api
        .configColumns({ tableName: "参与报价回收商", columns: transformedArr })
        .then((res) => {
          console.log("配置", res);
          if (res.code == 1) {
            this.toggleSelection();
            this.configShow = false;
          }
        });
    },
    handleSelectionChange(row) {
      this.configColumnsArr = [...row];
    },
    async onQuotePrice() {
      await this.handleOutConfigColumns();
      this.quotePriceShow = true;
    },
    // 外部商家报价
    handleOutConfigColumns() {
      this.quoteOperateLoading = true;
      console.log(this.orderNo, 333);

      const params = {
        orderNo: this.orderNo,
      };
      _api.getListQuoteByOrderNoOut(params).then((res) => {
        if (res.code === 1) {
          this.quotePriceData = res.data.list;
          (this.outMerchant = {
            maxMerchantName: res.data.maxMerchantName,
            maxQuoteSecretPrice: res.data.maxQuoteSecretPrice,
            quoteCondition: res.data.quoteCondition,
          }),
            (this.quoteOperateLoading = false);
        }
      });
    },
    viewPayer(row) {
      this.payInfo = {
        outPayChannel: row.outPayChannel, //付款信息  账户类型
        outPayStaffType:
          row.outPayChannel == "Store"
            ? row.outPayStaffIsMajor && row.outPayStaffType == "01"
              ? "创建人"
              : !row.outPayStaffIsMajor && row.outPayStaffType == "01"
                ? "子账号"
                : row.outPayStaffType == "02"
                  ? "总监"
                  : row.outPayStaffType == "03"
                    ? "店长"
                    : row.outPayStaffType == "04"
                      ? "店员"
                      : ""
            : row.outPayStaffIsMajor && row.outPayStaffType == "01"
              ? "创建人"
              : !row.outPayStaffIsMajor && row.outPayStaffType == "01"
                ? "子账号"
                : row.outPayStaffType == "02"
                  ? "报价师"
                  : "",
        outPayStaffName: row.outPayStaffName,
        outPayStaffMobile: row.outPayStaffMobile,
        outPayTime: row.outPayTime,
        outPayNo: row.outPayNo,
        // test000 : row.test000,
        outPayRefundTime: row.outPayRefundTime,
        outPayRefundNo: row.outPayRefundNo,
      };
      this.paymentShow = true;
    },
    storeClose() {
      this.storeShow = false;
      this.storeList = [];
      this.$refs.storeFormItemList.clearValidForm();

    },
    closebillDown() {
      this.isShowDownloadSuccess = false
    },
    billconfig() {
      this.isShowDownloadSuccess = false
      let routeData = this.$router.resolve({
        path: "/systemManage/downloadCenter",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>


<style scoped lang="scss" ref="stylesheet/scss">
::v-deep .orangeRow {
  background-color: #FFF5E6;
}

.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}

.handsStyle {
  cursor: pointer;
  font-size: 12px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  text-decoration: underline;
  color: #4c84ff;
}

.biliStyle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.command {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.command .el-input {
  width: 80%;
}

.function_box {
  max-height: 700px;
  overflow: auto;
}

.img-el-heard {
  display: flex;
  justify-content: center;

  img {
    margin: 0px 0 -3px 3px;
  }
}

.foot_buttom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.command {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}

.OrderTable {
  .top_bar {
    background: white;
    display: flex;
    justify-content: space-between;

    .case {
      display: flex;
      align-items: center;
      justify-content: space-between;
      align-items: center;

      .case-title {
        display: flex;

        .case-title_icon {
          width: 20px;
          height: 20px;
        }

        .case-title_max {
          font-weight: bold;
          color: #333333;
          font-size: 18px;
          // width: 80px;
          height: 17px;
          line-height: 17px;
          margin-left: 5px;
          font-family: FZLanTingHei-B-GBK;
        }
      }
    }
  }

  .orderPagina {
    float: right;
    margin: 50px;
  }

  .order_list {
    .line_top {
      background-color: white;
      width: 100%;
      height: 10px;
    }

    .table_title {
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        position: relative;
        align-items: center;

        // justify-content: space-between;
        div {
          margin-left: 30px;

          >div {
            margin-left: 0;
            width: 32px;
            height: 22px;
            background: #21d8c2;
            border-radius: 3px 11px 11px 3px;
            color: white;
            line-height: 22px;
            position: absolute;
            text-align: center;
            top: 0;
            left: -5px;
            margin-right: 10px;
          }

          >span {
            font-family: FZLanTingHei-DB-GBK;
            font-size: 14px;
            font-weight: 400;
            color: #0981ff;
          }

          >input {
            border: none;
            background: none;
            color: #0981ff;
            padding: 0;
            width: 140px !important;
            font-size: 14px;
          }

          >.copy {
            width: 36px;
            height: 16px;
            display: inline-block;
            line-height: 16px;
            text-align: center;
            background: #ff6600;
            color: #fff;
            margin-left: 8px;
            border-radius: 4px;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }

      .right {
        display: flex;
        color: #fff;

        .rightTrue {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: #ff687b;
          margin-right: 10px;
          border-radius: 5px;
          text-align: center;
        }

        .rightFalse {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: #ffaf29;
          margin-right: 10px;
          border-radius: 5px;
          text-align: center;
        }

        .rightFalseline {
          width: max-content;
          padding: 5px 10px;
          border: 1px solid #ff687b;
          border-radius: 14px !important;
          margin-right: 10px;
          text-align: center;
          font-size: 12px;
          font-family: FZLanTingHei-DB-GBK;
          font-weight: 400;
          color: #ff687b;
        }

        .rightMid {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: rgba(102, 204, 153, 1);
          margin-right: 10px;
          border-radius: 5px;
          text-align: center;
        }
      }
    }
  }
}

// 表格样式+
.position {
  width: max-content;
  display: block;
  padding: 0px 4px;
  font-size: 14px;
  background-color: rgba(102, 204, 153, 1);
  margin: 0 auto;
  border-radius: 5px;
  color: #fff;
  text-align: center;
}

.order-nice {
  // position: absolute;
  left: -80px;
  top: -1px;
  width: max-content;
  display: block;
  padding: 2px 8px;
  font-size: 14px;
  background-color: #81d3f8;
  margin: 0 auto;
  border-radius: 5px;
  color: #fff !important;
  text-align: center;
  margin-right: 10px;
}

.sty {
  margin-right: 10px;
  // position: absolute;
  // left: 0px;
  // top: -1px;
  width: max-content;
  background: #fca91f;
  border-radius: 14px;
  font-size: 14px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  color: #0981ff;
  padding: 3px 10px;
}

.solo {
  position: absolute;
  left: -80px;
  top: -1px;
  width: max-content;
  background: #fca91f;
  border-radius: 11px;
  font-size: 14px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  color: #ffffff !important;
  text-align: center;
  padding: 3px 10px;
  margin-right: 10px;
}

.solo2 {
  position: absolute;
  left: -80px;
  top: -1px;
  width: max-content;
  background: #7dc165;
  border-radius: 11px;
  font-size: 14px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  color: #ffffff !important;
  text-align: center;
  padding: 3px 10px;
  margin-right: 10px;
}

.order-online {
  position: absolute;
  left: -80px;
  top: -1px;
  width: max-content;
  display: block;
  padding: 0 5px;
  font-size: 12px;
  margin: 0 auto;
  border: 1px solid #ff687b;
  border-radius: 20px;
  color: #ff687b !important;
  text-align: center;
  margin-right: 10px;
}

.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.images-box>img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}

.images-box>span {
  color: #0981ff;
  cursor: pointer;
}

.color-green {
  color: rgba(102, 204, 153, 1);
}

.color-red {
  color: #ff687b;
}

.text-down {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}

// 弹窗
.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  // 列表
}

.noteLayout {
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.isdeal {
  background: #ff687b;
  margin-right: 5px;
  display: inline-block;
}

.sec_img {
  width: 20vw;
  height: 80vh;
  margin: auto;

  img {
    width: 20vw;
    height: 80vh;
    object-fit: contain;
  }
}

.cellnum {}

.autoshow::-webkit-scrollbar {
  display: none;
}

.onlyul {
  li {
    margin-top: 10px;
  }

  .firstli {
    margin: 0;
    color: #3a9aff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .firstli_span {
      color: #ccc;
    }
  }

  .secondli {
    color: #ff6600;
    // font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.quoteNotecss {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; //作为弹性伸缩盒子模型显示。
  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
  -webkit-line-clamp: 2; //显示的行
}

.flex {
  display: flex;
  align-items: center;
}

.flex-jb {
  display: flex;
  justify-content: space-between;
}

.add-price-title {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  line-height: 20px;
  padding-left: 10px;
  border-left: 3px solid #0981ff;
  margin-bottom: 10px;
  color: #0981ff;
  display: flex;
  align-items: center;
}

.add-price-conent {
  padding: 0 40px;

  .markup-coupon-box {
    width: 400px;
    height: 80px;
    background-image: url(https://img.fanxinghuishou.cn/20241210/125341172.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;

    .markup-coupon-box-left {
      width: 85px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 12px;

      .advance-amount {
        font-size: 24px;
      }
    }

    .markup-coupon-box-right {
      display: flex;
      flex-direction: column;
      margin-left: 15px;

      >p {
        margin-bottom: 5px;
      }

      .markup-coupon-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
    }
  }
}

.expected_info {
  margin-bottom: 40px;

  .expected_info_title {
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #0981ff;
    padding-left: 15px;
  }

  .expected_info_title::before {
    position: absolute;
    content: " ";
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    width: 3px;
    height: 21px;
    background: #0981ff;
    border-radius: 2px;
  }
}

.enable-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}

.platform_markup {
  font-size: 16px;
  color: #0981ff;
  margin-bottom: 10px;

  .grey_box {
    width: 100%;
    padding: 10px 20px;
    background-color: #f5f6fa;
    border-radius: 10px;
    margin-top: 20px;
    line-height: 30px;
    color: #333;
  }
}

.mt-10 {
  margin-top: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}

.deal_detail_title {
  // width: 100%;
  padding-left: 16px;
  font-size: 14px;
  font-weight: 900;
  color: #000;
  position: relative;
  margin-bottom: 10px;
  flex: 1;

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    background: #0c82ff;
    position: absolute;
    left: 0%;
    top: 50%;
    transform: translateY(-50%);
  }
}

.deal_detail_title1 {
  // width: 100%;
  padding-left: 16px;
  font-size: 14px;
  font-weight: 900;
  color: #000;
  position: relative;
  margin-bottom: 10px;
}

.deal_detail_title2 {
  font-size: 14px;
  color: #ff0000;
}

.deal_detail_inner {
  margin-bottom: 20px;
  background: #f2f2f2;
  font-size: 12px;
  color: #111;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 6px;
}

.deal_detail_line {
  margin-bottom: 16px;
}

.deal_detail_line-title {
  padding-left: 10px;
  position: relative;
  margin-bottom: 6px;
  font-weight: 600;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 5px;
    height: 5px;
    background: #000;
    border-radius: 50%;
    transform: translateY(-50%);
  }
}

.deal_detail_line-tips {
  transform: translateX(-5px);
}

.deal_detail_line-tips-blue {
  color: #0981fe;
}

.deal_detail_line-tips-red {
  color: #ff0000;
}

.test-function {
  margin-top: 20px;
}

.artificial-test-info {
  width: 100%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #646464;
  margin-bottom: 10px;
}

.system-result-title {
  color: #646464;
  font-size: 16px;
  margin-bottom: 10px;
}

.topPriceshoe {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.writquotation {
  margin-top: 15px;
  font-size: 16px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;

  span {
    font-size: 14px;
    color: #666666;
  }
}

.title_wt {
  margin-left: 10px;
  text-align: center;
  line-height: 16px;
  font-size: 12px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  color: #ffffff;
  width: 36px;
  height: 17px;
  background: #ffaf29;
  border-radius: 8px 8px 8px 1px;
}

.title_ht {
  background: #4c84ff;
}

.qb_act {
  display: flex;
  margin: 10px 0;

  .qukliy_box {
    cursor: pointer;
    font-size: 13px;
    margin-right: 10px;
    line-height: 13px;
    border-radius: 5px;
    padding: 5px 10px;
    background-color: #e4ecfd;
    color: rgb(9, 129, 255);
  }
}

.center_ptcon {
  margin: 20px 0;
  font-size: 15px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: bold;
  color: #333333;
}

.record_content {
  display: flex;
  width: 400px;
  height: 32px;
  background: #f9fbfd;
  border: 1px solid #d9e6ff;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 4px;
}

.scllo_center {
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  width: 100px;
  height: 30px;
  border-radius: 4px;
}

.action_scoll {
  color: #ffffff;
  background: #4c84ff;
}

.tp_left {
  display: flex;
  width: 240px;
  height: 76px;
  background: #f5f6fa;
  border-radius: 8px 4px 4px 4px;
}

.tpl_first {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 76px;
  background: #e6edfd;
  border-radius: 8px 0px 0px 4px;
}

.flost_tf {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 60px;
  height: 16px;
  line-height: 15px;
  background: #ff687b;
  border-radius: 8px 8px 8px 1px;
  font-size: 12px;
  font-family: FZLanTingHeiS-R-GB;
  font-weight: 400;
  color: #ffffff;
}

.tpl_first>p {
  text-align: center;
  width: 90px;
  font-size: 14px;
  font-family: FZLanTingHei-M-GBK;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.center_tf {
  width: 134px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
  }
}

.call_accounts_info {
  margin: 10px 0;
}

.call_accounts_check {
  margin-top: 10px;
  margin-bottom: 10px;
  // padding-left: 14px;
}

.call_accounts_result {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.baocunPrice {
  margin: 14px 0;
  display: flex;
  width: 651px;
  height: 70px;
  background: #f5f6fa;
  border-radius: 4px;
}

.xiuga_center {
  width: 120px;
  height: 70px;
  background: #f5f6fa;
  border-radius: 8px 4px 4px 4px;
  margin: 14px 0;
  margin-left: 12px;
}

.bp_pstyle {
  p {
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    color: #666666;
  }
}

.fs16 {
  font-size: 14px;
  margin-bottom: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

::v-deep .el-input {
  input[type="number"] {
    padding-right: 0px;
    -moz-appearance: textfield;
    -webkit-appearance: textfield;
    // 解决el-input设置类型为number时，中文输入法光标上移问题
    line-height: 1px !important;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.detail-price-box {
  font-size: 14px;
  color: #000;

  .outPay {
    display: flex;
    align-items: center;
    height: 30px;

    .outPay_title {
      font-weight: 700;
    }

    .outPay_tag {
      border: 1px solid #ff687b;
      padding: 0 3px;
      border-radius: 5px;
      margin-left: 10px;
      color: #ff687b;
    }
  }

  .outPay_info {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
  }

  .outPay_info1 {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 43px;
  }

  .mt-20 {
    margin-top: 20px;
  }
}

.isdeal1 {
  border: 1px solid #f59a23;
  display: inline-block;
  width: max-content;
  padding: 0px 4px;
  font-size: 14px;
  margin: 0 auto;
  border-radius: 5px;
  color: #f59a23;
  text-align: center;
  margin-left: 5px;
}

/deep/.el-statistic {
  width: 45px;
  display: inline-flex;
  height: 13px;
  margin-top: 2px;
  align-items: center;
}

.address-box {
  background-color: #f5f6fa;
  color: #666;
  width: 400px;
  margin: auto;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px 20px;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.price {
  color: red;
}

.negotiate-price-box {
  .negotiate-price-item {
    font-size: 14px;
    display: flex;

    .label-title {
      margin-right: 20px;
      height: 32px;
      display: flex;
      align-items: center;

      .label-must {
        color: #ff687b;
        margin-right: 4px;
      }
    }
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .price-content-item {
    position: relative;
    height: 65px;
    background-color: #f5f6fa;
    border-radius: 6px;

    .on-price-icon {
      position: absolute;
      top: 0;
      left: 0;
      font-size: 12px;
      padding: 2px 6px;
      border-radius: 6px 0 6px 0;
      background-color: #409eff;
      color: #fff;
      transform: scale(0.8); // 缩小元素 20%
      transform-origin: top left; // 保持元素的位置不变
    }

    .price-content-first {
      width: 80px;
      border-right: 1px solid #e4e7ed;
      text-align: center;
      color: #409eff;
      padding: 5px 0;
    }

    .price-content-after {
      width: 90px;
      text-align: center;
      color: #409eff;
    }

    .price-content-last {
      flex: 1;
      text-align: center;
      color: #409eff;
    }
  }
}

.auto-info-dia {
  .auto-info-dia-tip {
    font-size: 16px;
    margin-bottom: 10px;

    .general-blue {
      color: #0981FF;
    }

    .general-yellow {
      color: #ffbf54;
    }
  }

  .status_grd {
    color: #909399;
    height: 17px;
    display: flex;
    font-size: 12px;
    align-items: center;
    padding: 0 5px;
    border: 1px solid #909399;
    border-radius: 15px 15px 15px 4px;
    margin-left: 10px;

    &.abnormal {
      color: #ff687b;
      border: 1px solid #ff687b;
    }
  }

  &>p {
    margin: 5px 0;
  }
}

.express_title {
  width: 100px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical
}

.add-price-type {
  padding: 0 10px;
  height: 20px;
  color: #ff6600;
  font-size: 14px;
  border: 1px solid #ff6600;
  border-radius: 10px 10px 10px 0;
  margin-left: 10px;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.color-gray {
  color: #666666;
}

.bottominfo {
  padding-bottom: 20px;
}

.tabRound {
  cursor: pointer;
  margin-bottom: 40px;
  width: 280px;
  height: 32px;
  background: #F9FBFD;
  border: 1px solid #C1D1FF;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 16px;
  display: flex;

  .left {
    text-align: center;
    color: white;
    width: 50%;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 34px;
    height: 32px;
    background: #0981FF;
    border-radius: 16px;
  }

  .right {
    text-align: center;
    color: #333;
    width: 50%;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 34px;
    height: 32px;
    border-radius: 16px;
  }
}
</style>